/** Original AwareNow shield: an open A and a signal point represent awareness. */
export function AwareNowLogo({ compact = false, className = '' }: { compact?: boolean; className?: string }) {
  return (
    <span className={`awarenow-logo ${className}`} aria-label="AwareNow">
      <svg width="40" height="44" viewBox="0 0 40 44" fill="none" aria-hidden="true">
        <path d="M20 2 37 9v13c0 9-9 16-17 20C12 38 3 31 3 22V9L20 2Z" fill="currentColor" fillOpacity=".10" stroke="currentColor" strokeWidth="2" />
        <path d="m11 29 9-19 9 19M15 23h10" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="31" cy="9" r="4" fill="currentColor" />
      </svg>
      {!compact && <span className="awarenow-wordmark">Aware<span>Now</span><small>Awareness operations</small></span>}
    </span>
  );
}
